import React from "react";

const ProductContext = React.createContext({
  currentProduct: 0,
  setCurrentProduct: () => {},
});

export default ProductContext;
